export default {
  undo: {
    toolbar: 'Desfazer',
  },
  redo: {
    toolbar: 'Refazer',
  },
  clear: {
    toolbar: 'Limpar',
  },
  h: {
    toolbar: 'Cabeçalhos',
  },
  h1: {
    toolbar: 'Nível 1',
    placeholder: 'Nível 1',
  },
  h2: {
    toolbar: 'Nível 2',
    placeholder: 'Nível 2',
  },
  h3: {
    toolbar: 'Nível 3',
    placeholder: 'Nível 3',
  },
  h4: {
    toolbar: 'Nível 4',
    placeholder: 'Nível 4',
  },
  h5: {
    toolbar: 'Nível 5',
    placeholder: 'Nível 5',
  },
  h6: {
    toolbar: 'Nível 6',
    placeholder: 'Nível 6',
  },
  bold: {
    toolbar: 'Negrito',
    placeholder: 'Negrito',
  },
  italic: {
    toolbar: 'Itálico',
    placeholder: 'Itálico',
  },
  strikethrough: {
    toolbar: 'Riscado',
    placeholder: 'Riscado',
  },
  quote: {
    toolbar: 'Citação',
    placeholder: 'Citação',
  },
  ul: {
    toolbar: 'Lista Desordenada',
    placeholder: 'Lista Desordenada',
  },
  ol: {
    toolbar: 'Lista Ordenada',
    placeholder: 'Lista Ordenada',
  },
  table: {
    toolbar: 'Tabela',
  },
  hr: {
    toolbar: 'Linha',
  },
  link: {
    toolbar: 'Hyperlink',
    descPlaceholder: 'Hyperlink',
  },
  image: {
    toolbar: 'Imagem',
  },
  imageLink: {
    toolbar: 'Hyperlink de Imagem',
  },
  uploadImage: {
    toolbar: 'Upload de Imagem',
  },
  code: {
    toolbar: 'Bloco de Código',
  },
  save: {
    toolbar: 'Salvar',
  },
  preview: {
    enabled: 'Habilitar Prévia',
    disabled: 'Desabilitar Prévia',
  },
  toc: {
    title: 'Sumário',
    enabled: 'Habilitar Sumário',
    disabled: 'Desabilitar Sumário',
  },
  syncScroll: {
    enabled: 'Habilitar Scroll Automático',
    disabled: 'Desabilitar Scroll Automático',
  },
  fullscreen: {
    enabled: 'Entrar no modo em Tela Cheia (ESC para sair)',
    disabled: 'Sair do modo em Tela Cheia',
  },
}
